import {ValidatePassword, ValidatePasswordRepeat} from "../validators/indexValidator";

export function ResetPassword(target) {
    const urlParams = new URLSearchParams(window.location.search);
    
    const requestData = {
        e: urlParams.get("e"),
        uu: urlParams.get("uu")
    };
    
    $.ajax({
        data: JSON.stringify(requestData),
        async: false,
        contentType: "application/json",
        type: "POST",
        url: "/api/account/ResetPassword",
        beforeSend: function () {
            $(target).addClass("btn-disabled")
        },
        complete: function () {
        
        },
        success: function (data) {
            if (data.IsSuccess === true) {
                $("#resetPasswordOffer").css("display", "none");
                $("#resetPasswordResult").css("display", "block");
            }
        }
    })
}

export function SetNewUserPassword() {
    
    const newPasswordForm = $("#newPasswordForm");
    const newPasswordSet = $("#newPasswordSet");
    
    var status = $(".h2PassChangeStatus");
    status.html("");
    var valid = true;
    var Password = $("input[id$='tbxPass']:visible");
    var PasswordRepeat = $("input[id$='tbxPassRepeat']:visible");
    var validArr = [];
    validArr.push(ValidatePassword());
    validArr.push(ValidatePasswordRepeat());
    for (var i = 0; i < validArr.length; i++) {
        if (!validArr[i]) {
            valid = false;
            break;
        }
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    
    const requestData = {
        e: urlParams.get("e"),
        uu: urlParams.get("uu"),
        newPassword: Password.val()
    };
    
    if (valid) {
        $.ajax({
            url: "/api/account/SetNewPassword",
            data: JSON.stringify(requestData),
            async: true,
            type: "POST",
            contentType: "application/json",
            beforeSend: function () {
                $(".new-password-form .btn").addClass("show-loader");
            },
            complete: function () {
                $(".new-password-form .btn").removeClass("show-loader");
            },
            error: function (jqXHR, exception) {
                
                LogError(jqXHR, exception);
            },
            success: function (data) {
                if (data != null) {
                    if (data.Message.length > 0) {
                        status.html(data.Message);
                    }
                    
                    if (data.IsSuccess){
                        $(newPasswordForm).css("display", "none")
                        $(newPasswordSet).css("display", "block")
                    }
                }
            }
        });
    }
}

export function UpdateUserPass() {
    
    var status = $(".h2PassChangeStatus");
    status.html("");
    var valid = true;
    var Password = $("input[id$='tbxPass']:visible");
    var PasswordRepeat = $("input[id$='tbxPassRepeat']:visible");
    var validArr = [];
    validArr.push(ValidatePassword());
    validArr.push(ValidatePasswordRepeat());
    for (var i = 0; i < validArr.length; i++) {
        if (!validArr[i]) {
            valid = false;
            break;
        }
    }
    
    if (valid) {
        $.ajax({
            url: "/api/account/UpdatePassword",
            data: JSON.stringify(Password.val()),
            async: true,
            type: "POST",
            contentType: "application/json",
            beforeSend: function () {
                $(".new-password-form .btn").addClass("show-loader");
            },
            complete: function () {
                $(".new-password-form .btn").removeClass("show-loader");
            },
            error: function (jqXHR, exception) {
                
                LogError(jqXHR, exception);
            },
            success: function (data) {
                if (data != null) {
                    if (data.Message.length > 0) {
                        status.html(data.Message);
                    }
                }
            }
        });
    }
}
